import React, { Component } from "react";
import { pmt, rate, roundTo, formatter, templater } from '../utils/helpers'
import { ANNUAL_INTEREST, LOAN_AMOUNT, TENORS } from '../utils/constants';
import { Slider } from './inputComponents';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
export default class LoanCalculator extends Component {

  static DEFAULT_TENOR = 60

  constructor(props) {
    super(props)
    const minMonthlyMonthlyInstallment = this.calcualtedMonthlyInstallment(LOAN_AMOUNT.DEFAULT, LoanCalculator.DEFAULT_TENOR, ANNUAL_INTEREST.MIN)
    const maxMonthlyMonthlyInstallment = this.calcualtedMonthlyInstallment(LOAN_AMOUNT.DEFAULT, LoanCalculator.DEFAULT_TENOR, ANNUAL_INTEREST.MAX)
    this.state = {
      loanAmount: LOAN_AMOUNT.DEFAULT,
      tenor: LoanCalculator.DEFAULT_TENOR,
      minMonthlyMonthlyInstallment,
      maxMonthlyMonthlyInstallment,
      minApr: this.calculatedApr(LOAN_AMOUNT.DEFAULT, minMonthlyMonthlyInstallment, LoanCalculator.DEFAULT_TENOR),
      maxApr: this.calculatedApr(LOAN_AMOUNT.DEFAULT, maxMonthlyMonthlyInstallment, LoanCalculator.DEFAULT_TENOR),
    }
    this.refreshInfo = this.refreshInfo.bind(this)
    this.valueLabelFormat = this.valueLabelFormat.bind(this)
    this.tenorOptions = TENORS.map((e) => ({ value: e, label: null }))
  }

  refreshInfo() {
    const { loanAmount, tenor } = this.state;
    const minMonthlyMonthlyInstallment = this.calcualtedMonthlyInstallment(loanAmount, tenor, ANNUAL_INTEREST.MIN)
    const maxMonthlyMonthlyInstallment = this.calcualtedMonthlyInstallment(loanAmount, tenor, ANNUAL_INTEREST.MAX)
    const minApr = this.calculatedApr(loanAmount, minMonthlyMonthlyInstallment, tenor);
    const maxApr = this.calculatedApr(loanAmount, maxMonthlyMonthlyInstallment, tenor);
    this.setState({
      minMonthlyMonthlyInstallment,
      maxMonthlyMonthlyInstallment,
      minApr,
      maxApr
    });
  }

  onFieldChange(field) {
    return function (e, v) {
      let value = v
      if (!value)
        value = e.target.value;
      this.setState({
        [field]: parseInt(value)
      }, () => {
        this.refreshInfo()
      })
    }.bind(this)
  }
  calcualtedMonthlyInstallment(loanAmount, tenor, annualInterest) {
    return roundTo(pmt(annualInterest / 12, tenor, -loanAmount, 0, 0))
  }

  calculatedApr(loanAmount, installmentAmount, tenor) {
    return roundTo(Math.pow((1 + rate(tenor, installmentAmount, -loanAmount)), 12) - 1)
  }

  valueLabelFormat(value) {
    return this.tenorOptions.findIndex((mark) => mark.value === value) + 1;
  }

  render() {
    const { translations } = this.props;
    return (
      <div className='calculator loan'>
        <div className="header">
          <p>
            {translations.LoanCalculator.name}
          </p>
        </div>
        <Container className="calculatorBody">
            <Grid container spacing={2}>
              <Grid item xs={6} className='inputLabel'>
                <label className='inputLabel'>{translations.LoanCalculator.loanAmount}</label>
              </Grid>
              <Grid item xs={6}>
                <Input
                  startAdornment={< InputAdornment position='start'>HKD</InputAdornment>}
                  onChange={this.onFieldChange('loanAmount')}
                  onBlur={() => {
                    let remainder = parseInt(this.state.loanAmount) % 1000
                    let newValue = this.state.loanAmount - remainder;
                    if (newValue > LOAN_AMOUNT.MAX)
                      newValue = LOAN_AMOUNT.MAX
                    if (newValue < LOAN_AMOUNT.MIN)
                      newValue = LOAN_AMOUNT.MIN
                    this.onFieldChange('loanAmount')(null, newValue)
                  }}
                  value={this.state.loanAmount}
                />
              </Grid>
              <Grid item xs={12}>
                <Slider
                  defaultValue={200000}
                  min={5000}
                  step={1000}
                  max={800000}
                  aria-labelledby="discrete-slider-restrict"
                  valueLabelDisplay="off"
                  value={this.state.loanAmount}
                  onChange={this.onFieldChange('loanAmount')}
                />
              </Grid>
              <Grid item xs={6} className='inputLabel'>
                <label >{translations.common.tenor}</label>
              </Grid>
              <Grid item xs={6}>
                <Input
                  onChange={this.onFieldChange('tenor')}
                  onBlur={() => {
                    if (!TENORS.includes(this.state.tenor)) {
                      this.onFieldChange('tenor')(null, TENORS[0])
                    }
                  }}
                  value={this.state.tenor}
                  endAdornment={<InputAdornment position='end'>個月</InputAdornment>}
                />
              </Grid>
              <Grid item xs={12}>
                <Slider
                  defaultValue={48}
                  valueLabelFormat={this.valueLabelFormat}
                  min={6}
                  max={72}
                  step={null}
                  valueLabelDisplay="off"
                  marks={this.tenorOptions}
                  onChange={this.onFieldChange('tenor')}
                  value={this.state.tenor}
                />
              </Grid>
              <Grid item xs={6}>
                {translations.common.monthly_installment}
              </Grid>
              <Grid item xs={6}>
                {formatter('currency', this.state.minMonthlyMonthlyInstallment)}~{formatter('currency', this.state.maxMonthlyMonthlyInstallment)}
              </Grid>
              <ol className='declaraion'>
                  <li>
                    {
                      templater(translations.LoanCalculator.declaration_amount, { from: formatter('currency', LOAN_AMOUNT.MIN), to: formatter('currency', LOAN_AMOUNT.MAX)})
                    }
                  </li>
                  <li>
                    {
                      templater(translations.LoanCalculator.declaration_apr, { from: formatter('percentage', this.state.minApr), to: formatter('percentage', this.state.maxApr) })
                    }
                  </li>

              </ol>
              <div className="applyNowWrapper">
                <Button variant="outlined" color="primary" className='applyNow'>
                  {translations.LoanCalculator.applyNow}
                </Button>
              </div>
            </Grid>
        </Container>
      </div>
    )
  }
}


